export const createProductPayload = (currentState, pid, storeId) => {
  const { PRODUCT_TYPES } = require('../utils/constants');

  const productPayload = {
    productId: currentState.productId || null,
    productInstanceId: pid,
    storeId: storeId,
    productType: currentState.productType === PRODUCT_TYPES.STANDARD ? 1 : 2,
    productName: currentState.product.name,
    productDescription: currentState.product.description,
    productPrice: parseFloat(currentState.product.price.toFixed(2)),
    productImage: currentState.product.imageUrl,
    productImageType: "image/jpeg"
  };

  if (currentState.productType === PRODUCT_TYPES.DIGITAL) {
    productPayload.digital_product_file = {
      content_type: currentState.product.digitalFileContentType,
      content_length: currentState.product.digitalFileContentLength,
      file_status: 1,
      filename: currentState.product.digitalFileName,
      internal_filename: currentState.product.internalFilename,
      original_file_name: currentState.product.digitalFileName,
    };
    productPayload.downloadAttemptsLimit = 3;
    productPayload.downloadDaysLimit = 7;
    productPayload.downloadExpirationType = 1;
  }

  return productPayload;
};

export const createBusinessInfoPayload = (currentState, storeId) => {
  const businessInfoPayload = {
    store_id: storeId,
    company_name: currentState.businessInfo.companyName,
    company_address: currentState.businessInfo.address,
    company_email: currentState.businessInfo.email,
    currency: currentState.product.currency,
  };
  return businessInfoPayload;
};

export const createPublishPayload = (currentState, appInstanceId, productId) => {
  const publishPayload = {
    companyName: currentState.businessInfo.companyName,
    data: {
      storeId: appInstanceId,
      productId,
      needToPublish: true,
    },
  };
  return publishPayload;
};